<template>

	<!-- Information Card 2 -->
	<a-card :bordered="false" class="card-info-2 h-full">
		<div class="col-content h-full" :style="{background: 'url(' + $STATIC_URL + '/info-card-2.jpg)'}">
			<div class="card-content">
				<h5>{{ $t('info_23') }} {{$store.state.memberInfo.member_name}}!</h5>
				<p>{{ $t('info_24') }}</p>
			</div>
			<div class="card-footer">
				<a-button ghost shape="round" @click="$router.push('/calc_freight')">
					<span>{{ $t('info_25') }}</span>
					<a-icon type="arrow-right"></a-icon>
				</a-button>
			</div>
		</div>
	</a-card>
	<!-- / Information Card 2 -->

</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>